/* __next_internal_client_entry_do_not_use__ default auto */ import { createTheme } from "__barrel_optimize__?names=createTheme!=!@mui/material";
const theme = createTheme({
    typography: {
        fontFamily: 'Plus Jakarta Sans, sans-serif'
    },
    palette: {
        primary: {
            main: '#43bccd',
            contrastText: '#fff'
        }
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "&.Mui-focused": {
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#43bccd"
                        }
                    },
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#e5e7eb'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#43bccd'
                    },
                    backgroundColor: '#fff'
                }
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fff',
                    "&.Mui-focused": {
                        backgroundColor: '#fff'
                    },
                    '&:hover': {
                        backgroundColor: '#fff',
                        "& .MuiFilledInput-underline:before": {
                            borderColor: '#43bccd'
                        }
                    }
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    "&.Mui-focused": {
                        "& .MuiInput-notchedOutline": {
                            borderColor: "#43bccd"
                        }
                    }
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    "&.Mui-focused": {
                        "& .MuiInput-notchedOutline": {
                            borderColor: "#43bccd"
                        }
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    textTransform: 'none',
                    boxShadow: 'none'
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '12px'
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontSize: '18px',
                    fontWeight: 600,
                    padding: '16px'
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    marginTop: '16px',
                    marginBottom: '16px'
                }
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    borderTop: '1px solid #e5e7eb',
                    padding: '16px'
                }
            }
        }
    }
});
export default theme;
